import { ACTIONS } from "../../../Models/ENUM";
import ARRAY from "../../../UTIL/ARRAY";
import CONQUER from "../../CONQUER";
import TurnsInstance from "./TurnsInstance";
import GameInstance from "../GameInstance";
import RANDOM from "../../../UTIL/RANDOM";
import AvatarInstance from "../../AVATAR/AvatarInstance";
import LOG, { log } from "../../../UTIL/LOG";

class Turns
{
    private conquer         : CONQUER;
    public items            : any = [];
    private gameInstance    : GameInstance;
    public selected         : TurnsInstance | any;

    public yourItems        : any = [];
    public theirItems       : any = [];

    constructor( gameInstance:GameInstance )
    {
        this.gameInstance   = gameInstance;
        this.conquer        = gameInstance.conquer;
 
    }

    public async set( friendID?:any, vars?:any ) : Promise<any>
    {
        let avatarID            = this.conquer.Avatars.ME.avatarID;

        vars                    = vars || { isVS:this.conquer.Games.Game.CONFIG.MULTIPLAYER.module == "VS" };

        friendID                = this.gameInstance.Rivals.set( friendID ).avatarID;
 
        let isBot               = this.conquer.Avatars.data[ friendID ].isBot;

        let query               = ARRAY.extract( vars, { avatarID:avatarID, firstTurn:avatarID, avatarIDs:[ friendID ], isBot:isBot, gameID:this.gameInstance.gameID } ); 
 
        return this.setQuery( query );
    }

    public async setBot( bot:AvatarInstance ) : Promise<any>
    {
        let avatarID                        = bot.avatarID;
        let query                           = { isVS:this.conquer.Games.Game.CONFIG.MULTIPLAYER.module == "VS", isBot:true, avatarIDs:[ this.conquer.Avatars.ME.avatarID ], avatarID:avatarID, firstTurn:avatarID, gameID:this.gameInstance.gameID };
        let turnInstance : TurnsInstance    = await this.setQuery( query );

        await turnInstance.setBot();

        return turnInstance;
    }

    private async setQuery( query:any ) : Promise<any>
    {
        let value               = await this.conquer.do( ACTIONS.GAME_TURN_SET, query );

        let turnInstance        = await this.pushInstance( value );
 
        return Promise.resolve( turnInstance ? this.select( turnInstance ) : null );
    }
 
    public async get() : Promise<any>
    {
        this.deselect(); 

        let vars = { avatarID:this.conquer.Avatars.ME.avatarID, gameID:this.gameInstance.gameID };

        let values      = await this.conquer.do( ACTIONS.GAME_TURN_GET, vars );

        this.items      = [];
 
        for( let n in values ) await this.pushInstance( values[n] );

        this.refresh();

        return Promise.resolve( this.items );
    }

    public refresh()
    {
        this.yourItems  = [];
        this.theirItems = [];

        this.items      = ARRAY.sort( this.items, "lastChange" );

        for( let n in this.items )
        {
            let item : TurnsInstance = this.items[n];

            if( item.currentAvatarID === this.conquer.Avatars.ME.avatarID )
            {
                this.yourItems.push( item );
                continue;
            }

            this.theirItems.push( item );
        }

        this.gameInstance.Data.display( "yourTurnCount", this.yourItems.length );
        this.gameInstance.Data.display( "theirTurnCount", this.theirItems.length );

        this.gameInstance.Signal.set( "TURNS:onRefresh" );
    }

    private async pushInstance( value:any ) : Promise<any>
    {
        let turnInstance        = new TurnsInstance( this.gameInstance, value );
 
        if( !turnInstance.isValid || turnInstance.viewedResults.includes( this.conquer.Avatars.ME.avatarID ) ) return Promise.resolve();

        await turnInstance.init();

        this.items.push( turnInstance );
 
        return Promise.resolve( turnInstance )
    }

    public select( turnsInstance: TurnsInstance )
    {
        this.selected = turnsInstance;
        
        turnsInstance.select();

        return turnsInstance;
    }

    public deselect()
    {
        this.selected = null;
    }

    public remove( turnsInstance: TurnsInstance )
    {
        ARRAY.removeItem( this.items, turnsInstance );
        ARRAY.removeItem( this.yourItems, turnsInstance );    
        ARRAY.removeItem( this.theirItems, turnsInstance );    

        this.refresh();

        if( this.selected === turnsInstance ) this.deselect();
    }
 

};

export default Turns;